module.exports = __webpack_public_path__ + "static/img/payment_logos.8cd978c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment_logos.svg
// module id = 313
// module chunks = 12 14